import React, { useEffect, useState } from 'react';
import { Iconfont, UmuInput } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import { KEY_CODE } from '@umu/umu-types';
import { components } from 'common';
import './index.scss';
import { classSet } from '@umu/umu-dom';
import { isInApp } from '@umu/umu-ua';

interface IProps {
    defaultValue?: string;
    content?: string | JSX.Element;
    onBack?: () => void;
    onSearch: (val: string) => void;
}
const { If } = components;

const HeardSearch = (props: IProps) => {
    const { defaultValue, onBack, onSearch } = props;
    const [value, setValue] = useState(defaultValue || '');
    const onKeyDown = (e: React.KeyboardEvent) => {
        const keyCode = e.keyCode;
        if (keyCode === KEY_CODE.KEY_ENTER) {
            onSearch(value);
            return false;
        }
        return true;
    };
    const onClear = () => {
        setValue('');
        onSearch('');
    };
    useEffect(() => {
        !defaultValue && setValue('');
    }, [defaultValue]);
    return (
        <div className={classSet({
            'comment-search-heard':true,
            'comment-search-heard-in-app': isInApp(),
        })}>
            <div className="search-input-info">
                <Iconfont type="Search" className="icon-search-info" />
                <UmuInput
                    value={value}
                    className="comment-search-input"
                    onChange={({ value }: { value: string }) => setValue(value)}
                    expandConfig={{ placeholder: lang('搜索'), autoFocus: true, onKeyDown }}
                />
                <If condition={value.length > 0}>
                    <Iconfont type="Delete2" className="icon-clear-info" onClick={onClear} />
                </If>
            </div>
            <div className="label-suffix" onClick={onBack}>
                {lang('取消')}
            </div>
        </div>
    );
};

export { HeardSearch };
